import { useLocation } from 'react-router-dom';
import NearestLocationLayout from './NearestLocationLayout';
import UserLayout from './UserLayout';

const PublicRoute = () => {
  const location = useLocation();
  
  // Check if user is authenticated
  const isAuthenticated = localStorage.getItem('isAuthenticated');
  
  if (!isAuthenticated) {
    // Redirect to login if not authenticated
    window.location.href = '/login';
    return null;
  }
  
  if (location.pathname === '/nearest-location') return <NearestLocationLayout />
  else return <UserLayout />;
};

export default PublicRoute;
